<script setup lang="ts">
import { pinia } from '@/stores'
import { useRouterStore } from '@/stores/router'
import { onMounted, onUnmounted, ref } from 'vue'
import AppButton from '../ui/AppButton.vue'
import { cleanQueryString } from '@/utils/router'
import { getStore, removeStore } from '@/utils/remote-diagnose'
import { getLimitDate, removeLimitDate } from '@/utils/limit-date'
import { useLang } from '@/composables/use-lang'
import PaymentResultContent from '@/lang/payment-result.json'

const { push, current } = useRouterStore(pinia)

const emit = defineEmits(['scroll'])

const langContent = useLang(PaymentResultContent)

const has_dongle = ref<boolean>(false)

const error = ref<boolean>(false)

const handleNext = () => {
  push('payment')
}

onMounted(async () => {
  if (current.params.redirect_status === 'failed') {
    error.value = true
    return null
  }

  const user = getStore()

  if (user) {
    has_dongle.value = user.has_dongle
    removeStore()
  }

  if (getLimitDate()) {
    removeLimitDate()
  }
})

onUnmounted(() => {
  emit('scroll')
  cleanQueryString()
})
</script>

<template>
  <div v-if="langContent" class="text-center">
    <h2 class="mb-10">{{ !error ? langContent.payment_success : langContent.payment_failure }}</h2>
    <div v-if="!error">
      <p>{{ langContent.thank_you_payment }}</p>
      <p v-if="has_dongle">{{ langContent.whatsapp_instruction }}</p>
      <p v-else>{{ langContent.dongle_request }}</p>
      <p class="mt-10 mb-5">{{ langContent.diagnostic_info_part_one }}</p>
      <p class="mb-10">{{ langContent.diagnostic_info_part_two }}</p>
      <p>{{ langContent.contact_us }}</p>
    </div>
    <p v-else>{{ langContent.payment_error }}</p>
    <app-button class="mx-auto mt-10" v-if="error" @click="handleNext">{{
      langContent.retry
    }}</app-button>
  </div>
</template>
